import StatCard from "./stat/StatCard";
import TableView from "./table/TableView";

export default function PlacementListPage() {
  return (
    <>
      <StatCard />
      <TableView />
    </>
  );
}
